import { initializeIcons } from '@fluentui/react';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import { authRedirectPath, silentAuthRedirectPath } from './app/authentication/AuthServiceProvider';
import AuthCallbackPage from './pages/auth/AuthCallbackPage';
import SilentAuthCallbackPage from './pages/auth/SilentAuthCallBackPage';
import { store } from "./redux/store";
import { Provider } from "react-redux";
import ProtectedRoutes from './app/authentication/ProtectedRoutes';
import QueueReports from './pages/queues/QueueReportsPage';
import TeamsReports from './pages/teams/TeamsReportsPage';
import Providers from './providers/Index';

initializeIcons();

function App(): JSX.Element {
  return (
    <Provider store={store}>
      <Providers>
        <BrowserRouter>
              <Routes>
                  <Route path={authRedirectPath} element={<AuthCallbackPage />} />
                  <Route path={silentAuthRedirectPath} element={<SilentAuthCallbackPage />} />
                  <Route path="/" element={<ProtectedRoutes>{{node:<TeamsReports/>}}</ProtectedRoutes>}/>
                  <Route path="/QueueReports" element={<ProtectedRoutes>{{node:<QueueReports/>}}</ProtectedRoutes>}/>
                  <Route path="/TeamsReports" element={<ProtectedRoutes>{{node:<TeamsReports/>}}</ProtectedRoutes>}/>
              </Routes>  
        </BrowserRouter>
      </Providers>
    </Provider>
  );
}

export default App;